export default __webpack_public_path__ + "static/ilpapps-intro-e84ac70c7b41913168c79b6425c3ee9c.mp4";